import $axios from '~/plugins/axios';

import { Api, CampaignSplitFilterGroup, GetCampaignSplitFilterGroupParams } from '~/api';
import { buildModule } from '~/store/utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetCampaignSplitFilterGroupParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		filterGroupById: {} as Dict<CampaignSplitFilterGroup>,
		orderedIds: [] as number[],
		params: {} as LazyLoadingParams,
	})
	.withGetters({
		items: (state) => state.orderedIds.map(id => state.filterGroupById[id]),
		byId: (state) => (id: number): CampaignSplitFilterGroup | null => state.filterGroupById[id] ?? null,
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = { inFuture: false, inPast: false }) {
			state.params = params;
			state.orderedIds = [];
		},
		APPEND_FILTER_GROUPS (state, filterGroups: CampaignSplitFilterGroup[]) {
			state.filterGroupById = { ...state.filterGroupById, ...createDict(filterGroups, ({ id }) => id) };
			state.orderedIds = Array.from(new Set([ ...state.orderedIds, ...filterGroups.map(f => f.id) ]));
		},
		SET_FILTER_GROUPS (state, filterGroups: CampaignSplitFilterGroup[]) {
			state.filterGroupById = { ...state.filterGroupById, ...createDict(filterGroups, ({ id }) => id) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number | null = 20) {
			const params: GetCampaignSplitFilterGroupParams = { ...state.params, limit, offset: state.orderedIds.length };
			const { data } = await api.get('/campaign/split/filter-group', { params });
			commit('APPEND_FILTER_GROUPS', data.payload);
		},
		async prefetchFilterGroups ({ commit }, filterGroupIds: number[]) {
			const responses = await Promise.all(filterGroupIds.map(id => api.get(`/campaign/split/filter-group/${ id }`)));
			const filterGroups = responses.map(resp => resp.data.payload);
			commit('SET_FILTER_GROUPS', filterGroups.map(f => ({ id: f.id, name: f.name, filters: f.filters })));
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = { inFuture: false, inPast: false }) {
			commit('RESET', { ...state.params, ...params });
		},
	});


